import * as signalR from "@microsoft/signalr";

const orderHubService = {
    connection: null,

    async startConnection() {
        const token = localStorage.getItem('token'); // Get the access token from your authentication system
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl((process.env.VUE_APP_API_URL ?? "") + "/hubs/order", { accessTokenFactory: () => token })
            .build();

        await this.connection.start();
    },

    onReceiveMessage(callback) {
        this.connection.on("NewMessage", (message) => {
            callback(message);
        });
    },

    async sendMessage(message) {
        await this.connection.invoke("NewMessage", message);
    },

    async stopConnection() {
        await this.connection.stop();
    },

    async addToGroup(groupId) {
        await this.connection.invoke("AddToGroup", groupId);
    },

    async removeFromGroup(groupId) {
        await this.connection.invoke("RemoveFromGroup", groupId);
    },
};

export default orderHubService;